/** @typedef {{ product: object, children: TreeNode[] }} TreeNode */

/**
 * @param {object[]} products
 * @returns {{ roots: TreeNode[], productsById: Record<number, object> }}
 */
export function buildProductTree(products) {
  const productsById = {};
  /** @type {Record<number, TreeNode>} */
  const nodeById = {};
  for (const p of products) {
    productsById[p.id] = p;
    nodeById[p.id] = { product: p, children: [] };
  }

  const roots = [];
  for (const p of products) {
    const node = nodeById[p.id];
    const rawParent = p.parent_id;
    const parentId =
      rawParent != null && rawParent !== "" ? Number(rawParent) : null;
    const parentOk =
      parentId != null &&
      !Number.isNaN(parentId) &&
      parentId !== p.id &&
      nodeById[parentId];

    if (parentOk) {
      nodeById[parentId].children.push(node);
    } else {
      roots.push(node);
    }
  }

  const sortRec = (nodes) => {
    nodes.sort((a, b) => {
      const oa = a.product.sort_order != null ? Number(a.product.sort_order) : 0;
      const ob = b.product.sort_order != null ? Number(b.product.sort_order) : 0;
      if (oa !== ob) return oa - ob;
      const na = (a.product.name || "").toString().toLowerCase();
      const nb = (b.product.name || "").toString().toLowerCase();
      if (na < nb) return -1;
      if (na > nb) return 1;
      return a.product.id - b.product.id;
    });
    nodes.forEach((n) => sortRec(n.children));
  };
  sortRec(roots);

  return { roots, productsById };
}
